"use client";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useFileContent } from "../../../hooks/useFileContent";
import { SVG_SPRITE_DEFAULT_PROVIDER_ID } from "./SvgSprite.helpers";
const SvgSpriteProvider = ({ src, id, children }) => {
    const svgSpriteFileContent = useFileContent({
        src,
        spriteId: id !== null && id !== void 0 ? id : SVG_SPRITE_DEFAULT_PROVIDER_ID,
    });
    return (_jsxs(_Fragment, { children: [children, _jsx("div", { hidden: true, dangerouslySetInnerHTML: { __html: svgSpriteFileContent } })] }));
};
export default SvgSpriteProvider;
//# sourceMappingURL=SvgSpriteProvider.js.map